import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { KalturaLogger } from '@kaltura-ng/kaltura-logger';
import { BrowserService } from 'app-shared/kmc-shell/providers/browser.service';
import { Title } from '@angular/platform-browser';
import { AppLocalization } from '@kaltura-ng/mc-shared';
import { ContextualHelpService } from 'app-shared/kmc-shared/contextual-help/contextual-help.service';
import { KmcMainViewBaseService, ViewMetadata } from '../kmc-main-view-base.service';
import { KMCPermissions, KMCPermissionsService } from '../../kmc-permissions';

@Injectable()
export class ContentDropFoldersMainViewService extends KmcMainViewBaseService {
  constructor(
    logger: KalturaLogger,
    browserService: BrowserService,
    router: Router,
    private _appPermissions: KMCPermissionsService,
    appLocalization: AppLocalization,
    titleService: Title,
    contextualHelpService: ContextualHelpService,
  ) {
    super(
      appLocalization,
      logger.subLogger('ContentDropFoldersMainViewService'),
      browserService,
      router,
      titleService,
      contextualHelpService,
    );
  }

  isAvailable(): boolean {
    return this._appPermissions.hasAnyPermissions([KMCPermissions.DROPFOLDER_CONTENT_INGEST_DROP_FOLDER_BASE]);
  }

  getRoutePath(): string {
    return 'content/drop-folders';
  }

  getViewMetadata(): ViewMetadata {
    return {
      viewKey: 'content-drop-folders',
      title: this._appLocalization.get('app.titles.contentDropFoldersPageTitle'),
      menu: this._appLocalization.get('app.titles.contentDropFoldersMenuTitle'),
    };
  }
}
